import * as React from 'react';
import { Dimmer, Header, Loader } from 'semantic-ui-react';
import enhance from './enhancer';

function StripeDashboardRedirect(props) {
  const { isLoading } = props;

  return (
    <div className="app_stripe_dashboard_redirect flex">
      <Dimmer page active={isLoading}>
        <Loader active={isLoading} />
      </Dimmer>
      {!isLoading && (
        <div className="w__contents flex">
          <Header as="h1">売上げ受取口座を表示します</Header>
          <p>Stripe の画面を表示します。しばらくお待ちください。</p>
        </div>
      )}
    </div>
  );
}

export default enhance((props) => <StripeDashboardRedirect {...props} />);
